module.exports = __webpack_public_path__ + "static/logo_icon-cae7a0152a9fba6a00db0afe7ee4eb02.png";